module.exports = __webpack_public_path__ + "img/expression-great.1fe62273.png";